import data from '@data/data.json'
import { Enzyme as EnzymeData } from '@interfaces/enzyme'
import ModelEnzyme from '@models/enzyme'
import collect, { Collection } from 'collect.js'

export default class EnzymeRepository {
  private repository: Map<string, EnzymeData>

  constructor() {
    this.repository = new Map()

    data.enzymes.forEach((enzyme) => {
      this.repository.set(enzyme.id, enzyme)
    })
  }

  public find(id: string): ModelEnzyme | undefined {
    if (!this.repository.has(id)) {
      return undefined
    }

    return new ModelEnzyme(this.repository.get(id) as EnzymeData)
  }

  public findByName(name: string): ModelEnzyme | undefined {
    const entry = [...this.repository.values()].find((item) => item.title === name)

    if (!entry) {
      return undefined
    }

    return new ModelEnzyme(this.repository.get(entry.id) as ModelEnzyme)
  }

  public all(): Collection<ModelEnzyme> {
    const all: Collection<ModelEnzyme> = collect()

    this.repository.forEach((enzymeData) => {
      all.push(new ModelEnzyme(enzymeData))
    })

    return all
  }
}
